import { Box } from "@mui/material";
import {
  GridFooterContainer,
  GridFooterContainerProps,
  GridPagination,
} from "@mui/x-data-grid";
import { uploadFilesTableActions } from "../../data/upload-files-table";
import Image from "../common/Image";
import { ActionsRowCta } from "../../models/uploaded-file";

export interface CustomFooterProps extends GridFooterContainerProps {
  onAction?: (cta: ActionsRowCta) => Promise<void>;
  selectedRowCount?: number;
}

const CustomFooter = ({
  onAction,
  selectedRowCount,
  ...props
}: CustomFooterProps) => {
  const actionButtonsWithoutView = () => {
    return uploadFilesTableActions.filter(
      (action) => action.cta !== ActionsRowCta.VIEW
    );
  };

  const onActionClick = (cta: ActionsRowCta) => {
    if (onAction) {
      onAction(cta);
    }
  };

  return (
    <GridFooterContainer
      {...props}
      sx={{
        width: "100%",
        height: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
      }}
    >
      {selectedRowCount ? (
        selectedRowCount > 0 && (
          <Box>
            {actionButtonsWithoutView().map((action) => (
              <Image
                key={action.cta}
                src={action.iconSrc}
                sx={{ cursor: "pointer" }}
                onClick={() => onActionClick(action.cta)}
              />
            ))}
          </Box>
        )
      ) : (
        <Box></Box>
      )}

      <GridPagination />
    </GridFooterContainer>
  );
};

export default CustomFooter;
